import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../../context/AuthContext';
import { SharedTaskRow } from './sharedDeskBits';
import { DeskEmpty, Eyebrow, SectionHead } from './essayShared';

// Everything the student has asked this person for, in one place.
export default function SharedTasksPage() {
  const { api } = useAuth();
  const { grant, grantId, desk, setDesk } = useOutletContext();
  const myTasks = desk.myTasks || [];
  const openTasks = myTasks.filter((t) => t.status !== 'DONE' && t.status !== 'DECLINED');

  const setTaskStatus = async (task, status, { notify } = {}) => {
    try {
      const res = await api.patch(`/college-access/shared/${grantId}/tasks/${task.id}`, {
        status,
        notify: notify === true,
      });
      setDesk((prev) => ({ ...prev, myTasks: prev.myTasks.map((t) => (t.id === task.id ? { ...t, status } : t)) }));
      if (res.data.delivery?.sent) toast.success(`Emailed ${grant.ownerName}`);
      else if (res.data.delivery?.error) toast.error("Saved, but the email didn't send");
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to update that task');
    }
  };

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '36px 32px 64px' }}>
      <Eyebrow>Asked of you</Eyebrow>
      <h1
        className="font-serif-editorial"
        style={{ fontSize: 44, fontWeight: 400, lineHeight: 1, margin: '0 0 28px', color: 'var(--college-ink)' }}
      >
        Your tasks
      </h1>

      <SectionHead
        title={openTasks.length ? 'Still to do' : 'All clear'}
        size={24}
        meta={`${openTasks.length} open · ${myTasks.length - openTasks.length} closed`}
      />

      {myTasks.length === 0 ? (
        <div style={{ marginTop: 20 }}>
          <DeskEmpty
            title="Nothing asked of you yet"
            body={`${grant.ownerName} can assign you a task from any essay. You'll be able to mark it done — or decline it, and they'll see either.`}
          />
        </div>
      ) : (
        <div
          style={{
            background: 'var(--college-panel)',
            border: '1px solid var(--college-border-soft)',
            borderTop: 'none',
            padding: '0 22px',
          }}
        >
          {myTasks.map((task) => (
            <SharedTaskRow key={task.id} task={task} grantId={grantId} ownerName={grant.ownerName} onStatus={setTaskStatus} />
          ))}
        </div>
      )}
    </div>
  );
}
